import React, { Component } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormGroup,
  FormFeedback,
  Button,
  Label,
  Input
} from 'reactstrap';
import Joi from 'joi-browser';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { Link } from 'react-router-dom';
import { users } from '../../services';
import FcmTable from './FcmTable';

class FcmMessages extends Component {
  constructor(props) {
    super(props);
    this.users = new users();
   
  }

  state = {
    AgentStatuses:'',
    AgentStatuseslist: [],
    provinces: [],
    partyCodeStatus: 0,
    cities: [],
    errors: {},
    messageTitle:'',
    messageBody:''
  };

  //schema
  schema = Joi.object().keys({
    messageBody: Joi.string()
      .required()
      .error(errors => {
        return {
          message: 'پارٹی کی قسم منتخب کریں'
        };
      }),
      messageTitle: Joi.string()
      .required()
      .error(errors => {
        return {
          message: 'پارٹی کوڈ کی ضرورت ہے'
        };
      }),
      AgentStatuses: Joi.string()
      .required()
      .error(errors => {
        return {
          message: 'پارٹی کا نام ضروری ہے'
        };
      }),


    
  });

  componentDidMount() {
   this.getuserlist();
  }

  getuserlist = async () => {
    try {
      let { data } = await this.users.getAgents();
      let all={
        "agent_status_id": 5,
        "agent_status_name": "All"
    }
    data.response.push(all)
      this.setState({ AgentStatuseslist: data.response});
    
    } catch (error) {}
  };

  getCity = async id => {
    try {
      console.log("this is id of agent",id)
      //this.setState({ cities: data['response'] });
    } catch (error) {}
  };

  //change handler

  //change handler
 

  // validation
  validation() {
    let { error } = Joi.validate(this.state.party, this.schema, {
      abortEarly: false
    });

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err['message']));

    return errors;
  }


  // Submit handler
  handleSubmit = async event => {
    event.preventDefault();

    // validation
    let errors = this.validation();

    if (errors) {
      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    if (this.state.partyCodeStatus) {
      return;
    }

    let { party } = this.state;
let data1={
    'title':this.state.messageTitle,
    'body':this.state.messageBody,
    'status':this.state.AgentStatuses

}
    try {
        var { status, data } = await this.users.sendMessage(data1);
      if (status === 200) {
        // show verification modal
        toast.success('-کامیابی کے ساتھ بھیج دیا گیا', {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
        this.setState({messageTitle:'',messageBody:''})
        //this.reset();
      }
    } catch (error) {
      // error occur

      toast.error('کچھ دیر بعد کوشش کریں _ ہم معزرت خواہ ہیں', {
        position: toast.POSITION.BOTTOM_RIGHT,
        transition: Slide
      });
    }
  };

  render() {
    let { errors, AgentStatuseslist,messageBody,messageTitle } = this.state;
 



    const AgentStatusList = AgentStatuseslist.map(p => (
      <option key={p['agent_status_id']} value={p['agent_status_id']}>
        {p['agent_status_name']}
      </option>
    ));

   

    return (
      <div>
        <Breadcrumb style={{ marginTop: '1%' }}>
          <BreadcrumbItem>
            <Link to='/dashboard'>Dashbarod</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Create</BreadcrumbItem>
        </Breadcrumb>

        {/* party form */}
        <div className='mt-3 text-right'>
          <div className='card'>
            <div className='card-header bg-secondary text-white h4'>
            FCM Messages
            </div>
            <div className='card-body'>
              <Form className='row'>
              <FormGroup className='col-sm-12 col-md-4 '>
                  </FormGroup>

                <FormGroup className='col-sm-12 col-md-4'>
                  <Label for='phoneNumber'>میسیج ٹائٹل</Label>
                  <Input
                    type='text'
                    value={messageTitle}
                    name='messageTitle'
                    id='messageTitle'
                    placeholder='میسیج ٹائٹل'
                    invalid={Boolean(errors['messageBody'])}
                    onChange={(e)=>{this.setState({messageTitle:e.target.value})}}
                  />
                  {errors['messageTitle'] && (
                    <FormFeedback>{errors['messageTitle']}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup className='col-sm-12 col-md-4 '>
                  <Label for='province'>ایجنٹ کی حیثیت</Label>
                  <Input
                    type='select'
                    name='AgentStatuses'
                    id='AgentStatuses'
                    invalid={Boolean(errors['AgentStatuses'])}
                    onChange={(e)=>{this.setState({AgentStatuses:e.target.value})}}
                  >
                    <option value=''>Select Agent Status</option>
                    {AgentStatusList}
                  </Input>
                </FormGroup>
           


                

                <FormGroup className='col-sm-12 col-md-12'>
                  <Label for='address'>میسیج باڈی</Label>
                  <Input
                    value={messageBody}
                    name='messageBody'
                    id='messageBody'
                    placeholder='میسیج باڈی'
                    invalid={Boolean(errors['messageBody'])}
                    onChange={(e)=>{this.setState({messageBody:e.target.value})}}
                  />
                  {errors['messageBody'] && (
                    <FormFeedback>{errors['messageBody']}</FormFeedback>
                  )}
                </FormGroup>
             

                <div className='col-sm-12 col-md-12 text-left'>
                  <Button
                    className='small '
                    color='success'
                    onClick={this.handleSubmit}
                  >
                    بھیج دیں
                  </Button>
                </div>
              </Form>

              {/* toast notifiction */}
              <ToastContainer />
            </div>
          </div>
        </div>
        <FcmTable/>
      </div>
    );
  }
}

export default FcmMessages;
